module.exports = "/_next/static/images/38de2b212118e33917e20eba70615599-celebration.svg";